<template>
    <div class="d-flex flex-row">
        <DefaultEditorButtonPaneComponent 
            :context="context" ref="defaultEditorButtonPane"
        >
            <template v-slot:append>
                <v-btn ref="loadTicketButton"
                    color="success"  class="mr-1 left-round"
                    :dark="false"
                    :disabled="loadTicketButtonDisabled()"
                    @click="loadTicketButtonClicked">
                    <v-icon>mdi-file-outline</v-icon>
                    <span>加载交易流水</span>            
                </v-btn>

                <v-btn ref="selectActivityButton"
                    color="success" class="mr-1"
                    :dark="false"
                    :disabled="selectActivityButtonDisabled()"
                    @click="selectActivityButtonClicked">
                    <v-icon>mdi-calculator-variant</v-icon>
                    <span>选择赠券活动</span>            
                </v-btn>

                <v-btn ref="printCouponButton"
                    color="pink" class="mr-1 right-round"
                    :dark="false"
                    :disabled="printCouponButtonDisabled()"
                    @click="printCouponButtonClicked">
                    <v-icon>mdi-cloud-print</v-icon>
                    <span>券打印</span>            
                </v-btn>
            </template>
             
        </DefaultEditorButtonPaneComponent>

        
        
    </div>
</template>

<script>

    import DefaultEditorButtonPaneComponent from '../../../../base/bill/EditorButtonPane.vue';
    

    export default {

        name:'SmMarketPintcouponBackendSendEditorButtonPane',
        props:['context'],
        components:{
            'DefaultEditorButtonPaneComponent':DefaultEditorButtonPaneComponent,
        },
        data () {
            return {
            };
        },
        methods:{
            getContext(){
                return this.context;
            },
            getSignals () {
                return this.context.signals;
            },
            getModeHelper(){
                return this.context.modeHelper;
            },

            getEditorPane(){
                return this.context.bill.getEditorPane();
            },
            getEditor(){
                let editorPane = this.getEditorPane();
                if(editorPane && editorPane.getEditor)
                    return editorPane.getEditor();
                return null;
            },

            getEditorSelectedAppoint(){
                let editor = this.getEditor();
                if((!editor)||(!editor.getSelectedAppoints))
                    return null;
                let appoints = editor.getSelectedAppoints();
                if(!appoints || !appoints.length || appoints.length<1)    
                    return null;
                return appoints[0];    
            },

            getDefaultEditorButtonPane(){
                return this.$refs.defaultEditorButtonPane;
            },

            initComponent(){},
            initSignals(){
                //let signal = this.getSignals().editCancelAsked;
                //signal.dispatch();
            },

            loadTicketButtonClicked(){
                let me = this;
                let editor = this.getEditor();
                if(!editor)
                    return null;
                let signal = this.getSignals().customCommandAsked;
                signal.dispatch({command:"LOAD_TICKET",options:{}});    
            },
            
            selectActivityButtonClicked(){
                let me = this;
                let editor = this.getEditor();
                if(!editor)
                    return null;
                let signal = this.getSignals().customCommandAsked;
                signal.dispatch({command:"SELECT_ACTIVITY",options:{}});
            },
            printCouponButtonClicked(){
                console.log('printCoupon clicked');
                let editor = this.getEditor();
                if(!editor)
                    return null;
                let signal = this.getSignals().customCommandAsked;
                signal.dispatch({command:"PRINT_COUPON",options:{}});
            },
            getButtonTextPermited(text){
                let billSupportedActions = this.getModeHelper().billSupportedAction;
                for(var idx in billSupportedActions){
                    let action = billSupportedActions[idx];
                    if(action.name == text)
                        return true;
                }
                return false;
            },
            loadTicketButtonPermited(){
                return this.getButtonTextPermited('载入交易流水');
            },
            selectActivityButtonPermited(){
                return this.getButtonTextPermited('选择赠券活动');
            },
            printCouponButtonPermited(){
                return this.getButtonTextPermited('券打印');
            },
            
            //editorCan

            loadTicketButtonDisabled(){
                let editor = this.getEditor();
                
                //console.log("loadTicketButtonDisabled");
                //console.log(this.loadTicketButtonPermited());
                //console.log(this.getEditorPane().isEditing());
                //console.log(this.getEditorPane().isEmptyData());
                
                // return (!this.loadTicketButtonPermited())
                // || (!this.getEditorPane())
                // || (!this.getEditorPane().isEditing());
                return true;
            },

            selectActivityButtonDisabled(){
                let editor = this.getEditor();
                
                //console.log("selectActivityButtonPermited");
                //console.log(this.loadTicketButtonPermited());
                //console.log(this.getEditorPane().isEditing());
                //console.log(this.getEditorPane().isEmptyData());
                
                return (!this.selectActivityButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isEditing());
                //return true;
            },
 
            printCouponButtonDisabled(){
                
                // console.log("printCouponButtonDisabled");
                // console.log(this.printCouponButtonPermited());
                // console.log(this.getEditorPane().isBrowsing());
                // console.log(this.getEditor().canPrintCoupon());
                
                return (!this.printCouponButtonPermited()) 
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditor().canPrintCoupon());
            },
        },
        computed:{
            
        },
        created () {
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
    }

</script>

<style scoped>
</style>
